<!-- 选择点位弹窗 -->
<template>
  <dialog-reset
    top="1vh"
    width="80%"
    height="70vh"
    title="选择巡检点位"
    :visible.sync="dialogVisible"
    :appendToBody="false"
    :modalShow="false"
  >
    <div class="point-dialog">
      <point-table
        ref="pointTable"
        :select-mode="true"
        :only-enabled="true"
        :on-select="handleSelectionChange"
        @list-loaded="onPointTableListLoaded"
      />
    </div>

    <div slot="dialog_footer" >
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :disabled="selectedData.length === 0">
        确定
      </el-button>
    </div>
  </dialog-reset>

</template>

<script>
import PointTable from "../../InspectionPointManage/components/PointTable.vue";

export default {
  name: "PointDialog",
  components: {
    PointTable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedPoints: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedData: [],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        if (!val) {
          this.selectedData = [];
        }
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.selectedData = [];
      }
    },
    selectedPoints: {
      handler() {
        if (this.visible) {
          this.$nextTick(() => {
            this.setSelectedRows();
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    onPointTableListLoaded() {
      if (!this.visible) {
        return;
      }
      this.setSelectedRows();
    },

    // 设置已选中的行（回显）
    setSelectedRows() {
      if (!this.selectedPoints || this.selectedPoints.length === 0) {
        return;
      }

      const pointTable = this.$refs.pointTable;
      if (!pointTable) {
        return;
      }

      const tableData = pointTable.data || [];
      if (tableData.length === 0) {
        return;
      }

      const norm = (v) => String(v == null ? "" : v).trim();
      const codeSet = new Set(
        this.selectedPoints.map(norm).filter(Boolean)
      );

      pointTable.setSelection(this.selectedPoints);

      this.$nextTick(() => {
        this.selectedData = tableData.filter((row) =>
          codeSet.has(norm(row.pointCode))
        );
      });
    },

    // 选择变化处理
    handleSelectionChange(selection) {
      this.selectedData = selection;
    },

    // 取消
    handleCancel() {
      this.dialogVisible = false;
    },

    // 关闭
    handleClose() {
      this.selectedData = [];
    },

    // 确认：勾选集即路线点位集（可取消勾选去掉点）；未勾选任何项时二次确认后清空序列
    handleConfirm() {
      const rows = Array.isArray(this.selectedData) ? [...this.selectedData] : [];
      if (rows.length === 0) {
        this.$confirm(
          "当前未勾选任何点位，确认后将清空本路线的点位序列。保存路线前仍需至少添加一个点位。",
          "清空点位",
          {
            confirmButtonText: "确定清空",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.$emit("confirm", []);
            this.dialogVisible = false;
          })
          .catch(() => {});
        return;
      }
      this.$emit("confirm", rows);
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.point-dialog {
  min-height: 450px;
  ::v-deep .avue-crud__menu {
    display: none !important;
  }
}



</style>
